import type { Copy } from "../types";

export const ms: Copy = {
    seo: {
      title: "Kalkulator Umur Kenderaan | semak usia kenderaan mengikut tahun dan bulan",
      description:
        "Semak umur tepat kenderaan daripada tahun pembuatan dan bulan pilihan. Lihat tahun, bulan, hari, jumlah hari, dan pencapaian penting dalam satu alat yang kemas.",
      keywords: [
        "kalkulator umur kenderaan",
        "kalkulator umur kereta",
        "semak tahun pembuatan kereta",
        "semak bulan pembuatan kenderaan",
        "umur kereta saya",
        "semak umur kereta mengikut tahun",
        "semak umur kenderaan",
        "kalkulator umur RC",
        "semak umur kereta mengikut bulan",
        "kalkulator tarikh kenderaan",
        "mParivahan alternatif",
        "Parivahan alternatif",
        "kalkulator umur kenderaan RTO",
        "semak umur pendaftaran kereta",
        "umur pendaftaran kenderaan",
      ],
      faq: [
        {
          question: "Apa yang dilakukan oleh kalkulator ini?",
          answer:
            "Ia mengira umur tepat kenderaan daripada tahun pembuatan yang dipilih dan bulan pilihan, kemudian memaparkan tahun, bulan, hari dan maklumat pencapaian.",
        },
        {
          question: "Mengapa ada bulan pilihan?",
          answer:
            "Tetapan bulan memberikan pengiraan umur yang lebih tepat. Jika anda tidak memilih bulan, sistem akan menggunakan Januari bagi tahun yang dipilih.",
        },
        {
          question: "Bolehkah saya memilih tahun atau bulan masa depan?",
          answer:
            "Tidak. Tahun masa depan disekat dan bulan masa depan dilumpuhkan apabila tahun yang dipilih ialah tahun semasa.",
        },
      ],
    },
    headerTagline: "Utiliti kenderaan",
    headerTitle: "Kalkulator Umur Kenderaan",
    reset: "Tetapkan semula",
    switchToLight: "Tukar ke mod cerah",
    switchToDark: "Tukar ke mod gelap",
    languageLabel: "Bahasa",
    languageEnglish: "Bahasa Inggeris",
    languageHindi: "Bahasa Hindi",
    heroEyebrow: "Umur kereta, jelas",
    heroTitle: "Alat tarikh yang kemas untuk umur kenderaan.",
    heroDescription: "Pilih tahun pembuatan. Tambah bulan hanya jika anda mahu hasil yang lebih tepat.",
    yearSelectLabel: "Tahun pembuatan",
    monthSelectLabel: "Bulan pembuatan",
    includeMonthLabel: "Sertakan bulan khusus untuk lebih ketepatan",
    includeMonthNote: "Jika bulan tidak disertakan, Januari akan digunakan untuk pengiraan.",
    yearOnlyBadge: "Tahun sahaja",
    yearMonthBadge: "Tahun + bulan",
    yearPlaceholder: "Pilih tahun",
    monthPlaceholder: "Pilih bulan",
    inputTitle: "Tahun pembuatan",
    inputLabel: "Tahun pembuatan",
    blockedDateNote: "Tahun masa depan disekat.",
    result: "Keputusan",
    vehicleAgeLead: "Kenderaan anda",
    asOfToday: "Setakat hari ini",
    years: "Tahun",
    months: "Bulan",
    days: "Hari",
    totalDays: (count) => `${count.toLocaleString("en-IN")} jumlah hari`,
    ageLabels: { almostNew: "Hampir baharu", modern: "Moden", mature: "Matang", classic: "Klasik" },
    estimatedValue: {
      high: "Potensi jual semula tinggi",
      healthy: "Nilai kekal baik",
      moderate: "Susut nilai sederhana",
      collector: "Minat pengumpul boleh meningkat",
    },
    maintenanceTitle: "Penyelenggaraan",
    maintenance: {
      routine: "Servis rutin dan penjagaan OEM",
      watch: "Pantau brek, cecair dan tayar",
      plan: "Rancang komponen haus dan pemeriksaan",
      specialized: "Penyelenggaraan khusus menjadi lebih penting",
    },
    registrationTitle: "Pendaftaran",
    registration: {
      collector: "Di sesetengah kawasan mungkin layak untuk layanan pengumpul",
      classic: "Di sesetengah kawasan pendaftaran kereta klasik boleh dikenakan",
      standard: "Jangka pembaharuan standard dan semakan kawasan",
      regular: "Biasanya pendaftaran biasa digunakan",
    },
    upcomingMilestoneTitle: "Pencapaian seterusnya",
    milestoneTimelineTitle: "Garis masa pencapaian",
    milestoneRemaining: ({ label, days }) => `${label} dalam ${days.toLocaleString("ms-MY")} hari`,
    reached: "Tercapai",
    upcoming: "Akan datang",
    allMilestonesReachedTitle: "Semua pencapaian yang disenaraikan telah tercapai",
    allMilestonesReachedBody: "Kenderaan ini telah melepasi julat pencapaian yang dipaparkan dalam aplikasi.",
    copySummary: "Salin ringkasan",
    shareResult: "Kongsi keputusan",
    resetMessage: "Kalkulator telah ditetapkan semula",
    summaryCopied: "Ringkasan disalin ke papan klip",
    clipboardFailed: "Gagal mengakses papan klip",
    emptyTitle: "Pilih tahun pembuatan untuk melihat butiran penuh",
    emptyDescription:
      "Anda akan lihat umur tepat, jumlah hari, nota penyelenggaraan, status klasik, dan masa pencapaian selepas tahun dipilih.",
    shareTitle: "Kalkulator Umur Kenderaan",
    summary: ({ label, years, months, days, asOf }) =>
      `Kereta saya dibuat pada ${label} dan berumur ${years} tahun, ${months} bulan, ${days} hari setakat ${asOf}.`,
    milestones: {
      1: { label: "Tahun pertama", note: "Berguna untuk jaminan dan perancangan servis." },
      3: { label: "Tiga tahun", note: "Masa yang biasa untuk jual semula dan perubahan nilai." },
      5: { label: "Lima tahun", note: "Waktu yang baik untuk semak semula bajet penyelenggaraan." },
      10: { label: "Sepuluh tahun", note: "Komponen yang semakin usang perlu diberi perhatian." },
      15: { label: "Lima belas tahun", note: "Di banyak kawasan mula menerima layanan klasik." },
      25: { label: "Dua puluh lima tahun", note: "Boleh menarik minat pengumpul dan import di sesetengah pasaran." },
    },
  };
